// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Op-z","selected":"Pp-z"};